import { createAction } from "redux-act";

export const CanvasUpdateAction = createAction("Canvas Update");
export const CanvasUpdateRequestAction = createAction("Canvas Update - Request");
export const CanvasUpdateSuccessAction = createAction("Canvas Update - Success");
export const CanvasUpdateFailedAction = createAction("Canvas Update - Failed");
